/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Polygon specified in wkt or geojson, Coordinates in longitude, latitude order.
 * @export
 * @interface Polygon
 */
export interface Polygon {
  /**
   * Type should always be 'Polygon'
   */
  type: string;
  /**
   * List of coordinates (longitude, latitude order) in SRID 4326.
   */
  coordinates: Array<Array<Array<number>>>;
}

/**
 * Check if a given object implements the Polygon interface.
 */
export function instanceOfPolygon(value: object): value is Polygon {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("coordinates" in value) || value["coordinates"] === undefined) return false;
  return true;
}

export function PolygonFromJSON(json: any): Polygon {
  return PolygonFromJSONTyped(json, false);
}

export function PolygonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Polygon {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    coordinates: json["coordinates"],
  };
}

export function PolygonToJSON(json: any): Polygon {
  return PolygonToJSONTyped(json, false);
}

export function PolygonToJSONTyped(
  value?: Polygon | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
